import { DataGrid, DateBox, SelectBox } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { dataSourceSelect } from '../../services/store';
import http from '../../utils/http';
import { Column, Export, Summary, TotalItem } from 'devextreme-react/data-grid';

const ClaseReport = () => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState({
        instructor: '',
        date: ''
    });

    const loadReport = () => {
        setLoading(true);
        setError(null);
        setData([]);
        const params = {
            instructorId: filter.instructor,
            date: filter.date
        };

        http('clases/get-report').asPost(params).then(result => {
            setData(result);
            setLoading(false);
        }).catch(err => {
            setError(err);
            setLoading(false);
        });
    }

    const calculateCustomSummary =  (options) => {

        if (options.summaryProcess == "start") {
            options.totalValue = 0;
        }
        if (options.summaryProcess == "calculate") {
            if (options.value) {
                options.totalValue++;
            }
        }
                
    }

    const widthCol = 185;

    return (
        <div>
            <div className="container">
                <div className="row">   

                    <div className="col-md-1"/>
                    <div className="col-md-10">
                        <div className="input-group mb-3">
                            <div className="input-group-append">
                                <DateBox openOnFieldClick={true} defaultValue={new Date()} placeholder='Selecciona una fecha' type="date" value={filter.date} onValueChanged={e => setFilter({ ...filter, date: e.value })} />
                                <SelectBox
                                    
                                    width={450}
                                    value={filter.instructor}
                                    onValueChanged={e => setFilter({ ...filter, instructor: e.value })}
                                    searchEnabled={true}
                                    placeholder="Selecciona un instructor"
                                    showClearButton={true} 
                                    valueExpr="id" 
                                    displayExpr={item => item ? `${item.id} - ${item.name}` : ''} 
                                    dataSource={dataSourceSelect('instructors/get', 'instructors/get')}
                                />
                                <button disabled={!filter.instructor} className="btn btn-success" onClick={loadReport} type="button">
                                    {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Buscar'}
                                </button>
                            </div>
                        </div>
                    </div>
            
                </div>
                <div className="row">
                    <div className="col-md-1"/>
                    <div className="col-md-10">
                        {error && <div className="alert alert-danger" role="alert">
                            {error}
                        </div>}
                        <DataGrid 
                            dataSource={data} 
                            showBorders={true} 
                            showRowLines={true} 
                            showColumnLines={true} 
                            allowColumnReordering={false} 
                            allowColumnResizing={true} 
                            columnAutoWidth={true}
                            >
                                <Export enabled={true} allowExportSelectedData={true} />
                                <Column dataField="horario" width={80} />
                                <Column dataField="lunes" caption="Lunes" width={widthCol} />
                                <Column dataField="martes" caption="Martes" width={widthCol} />
                                <Column dataField="miercoles" caption="Miércoles" width={widthCol} />
                                <Column dataField="jueves" caption="Jueves" width={widthCol} />
                                <Column dataField="viernes" caption="Viernes" width={widthCol} />
                                <Column dataField="sabado" caption="Sábado" width={widthCol} />
                                <Summary calculateCustomSummary={calculateCustomSummary}>
                                    <TotalItem column={"lunes"} summaryType="custom" displayFormat="Horas: {0}"  />
                                    <TotalItem column={"martes"} summaryType="custom" displayFormat="Horas: {0}"  />
                                    <TotalItem column={"miercoles"} summaryType="custom" displayFormat="Horas: {0}"  />
                                    <TotalItem column={"jueves"} summaryType="custom" displayFormat="Horas: {0}"  />
                                    <TotalItem column={"viernes"} summaryType="custom" displayFormat="Horas: {0}"  />
                                    <TotalItem column={"sabado"} summaryType="custom" displayFormat="Horas: {0}"  />
                                </Summary>
                        </DataGrid>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-1"/>
                    <div className="col-md-10">
                            (*) Más de una clase registrada en la misma hora para el mismo alumno
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClaseReport;
